import React, { useState } from 'react';

function Home() {
  const [videosPlaying, setVideosPlaying] = useState({
    fuckAmerica: false,
    twistedWizard: false
  });

  const handleVideoClick = (videoKey: 'fuckAmerica' | 'twistedWizard') => {
    setVideosPlaying(prev => ({
      ...prev,
      [videoKey]: true
    }));
  };

  return (
    <main>
      <section className="hero">
        <div className="hero-content">
          <h1>WormWagon</h1>
          <p className="tagline">DMV Worm Core</p>
          <p className="hero-description">
            Raw, unfiltered fantasy metal from the heart of the DMV. 
            Dopegnome EP is now available!
          </p>
          <div className="hero-buttons">
            <a href="https://open.spotify.com/artist/55KU1zwKy2V6LW40wVLwEJ?si=RDh7G0RySumEH5djutT1Jg" target="_blank" rel="noopener noreferrer" className="cta-button">Listen Now</a>
            <a href="#latest-release" className="secondary-button">Latest Release</a>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-image-container">
            <img src="/images/band-photos/green_room2.PNG" alt="WormWagon in the Green Room" className="hero-band-image" />
            <div className="image-overlay"></div>
          </div>
        </div>
      </section>

      <section className="latest-release" id="latest-release">
        <h2>Latest Releases</h2>
        <div className="albums-grid">
          <div className="album-card">
            <div className="album-cover">
              {videosPlaying.fuckAmerica ? (
                <iframe 
                  src="https://www.youtube.com/embed/hAfUlAQbT7U?autoplay=1&si=CTnqWG3RuVdRCeae" 
                  title="Dopegnome - WormWagon" 
                  className="album-video"
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen>
                </iframe>
              ) : (
                <>
                  <img src="/images/album-covers/dopegnome cover.jpeg" alt="Dopegnome Album Cover" className="album-image" />
                  <div className="album-overlay" onClick={() => handleVideoClick('fuckAmerica')}>
                    <span className="play-icon">▶</span>
                  </div>
                </>
              )}
            </div>
            <div className="album-info">
              <h3>Dopegnome</h3>
              <p className="release-date">Latest Release</p>
              <p className="album-description">
                Dark fantasy emo.
              </p>
              <div className="streaming-buttons">
                <a href="https://open.spotify.com/track/3yetMDl9ZULqGoTNcn8UvQ?si=c6add1d3873846b5" target="_blank" rel="noopener noreferrer" className="stream-button spotify">Spotify</a>
                <a href="https://music.apple.com/us/song/invitation/1832454791" target="_blank" rel="noopener noreferrer" className="stream-button apple">Apple Music</a>
                <a href="https://music.youtube.com/watch?v=YRymZIyYkes&si=0vPu6BWEX7mMFDQF" target="_blank" rel="noopener noreferrer" className="stream-button youtube">YouTube Music</a>
                <a href="https://music.amazon.com/tracks/B0FLW37M34?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_DifYhJKzvskKtt8TAXknMCOQY" target="_blank" rel="noopener noreferrer" className="stream-button amazon">Amazon Music</a>
              </div>
            </div>
          </div>

          <div className="album-card">
            <div className="album-cover">
              {videosPlaying.twistedWizard ? (
                <iframe 
                  src="https://www.youtube.com/embed/1S-q10IJ4So?autoplay=1" 
                  title="Twisted Wizard - WormWagon" 
                  className="album-video"
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen>
                </iframe>
              ) : (
                <>
                  <img src="/images/album-covers/twisted wizard.JPG" alt="Twisted Wizard Album Cover" className="album-image" />
                  <div className="album-overlay" onClick={() => handleVideoClick('twistedWizard')}>
                    <span className="play-icon">▶</span>
                  </div>
                </>
              )}
            </div>
            <div className="album-info">
              <h3>Twisted Wizard</h3>
              <p className="release-date">Previous Release</p>
              <p className="album-description">
                A dark, twisted tale.
              </p>
              <div className="streaming-buttons">
                <a href="https://open.spotify.com/track/7bK6MX7tnLWg5TVwCyGAMo?si=72c88cf54bca4db1" target="_blank" rel="noopener noreferrer" className="stream-button spotify">Spotify</a>
                <a href="https://music.apple.com/us/song/twisted-wizard/1787799174" target="_blank" rel="noopener noreferrer" className="stream-button apple">Apple Music</a>
                <a href="https://music.youtube.com/watch?v=1S-q10IJ4So&si=530_-Oxy5_YDpoxZ" target="_blank" rel="noopener noreferrer" className="stream-button youtube">YouTube Music</a>
                <a href="https://music.amazon.com/tracks/B0DRM4SNHS?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_mb4G4M52bI1j3m33rcWVsbDQq" target="_blank" rel="noopener noreferrer" className="stream-button amazon">Amazon Music</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="social-links">
        <h2>Follow the Worm</h2>
        <div className="social-icons">
          <a href="https://instagram.com/wormwagon_band" target="_blank" rel="noopener noreferrer" className="social-icon">
            <span className="social-text">Instagram</span>
            <div className="social-icon-bg"></div>
          </a>
          <a href="https://tiktok.com/@wormwagon_band" target="_blank" rel="noopener noreferrer" className="social-icon">
            <span className="social-text">TikTok</span>
            <div className="social-icon-bg"></div>
          </a>
          <a href="https://www.youtube.com/@Wormwagon" target="_blank" rel="noopener noreferrer" className="social-icon">
            <span className="social-text">YouTube</span>
            <div className="social-icon-bg"></div>
          </a>
        </div>
      </section>
    </main>
  );
}

export default Home;